/** @typedef {'silk' | 'liquid-ether'} ArchonBackgroundEffectId */

export const ARCHON_BACKGROUND_EFFECTS = Object.freeze({
  /** Silk shader — flowing wave bands (classic Archon desktop). */
  SILK: 'silk',
  /** LiquidEther — interactive fluid simulation. */
  LIQUID_ETHER: 'liquid-ether',
});

/** @type {ArchonBackgroundEffectId} */
export const DEFAULT_BACKGROUND_EFFECT = ARCHON_BACKGROUND_EFFECTS.SILK;

export const BACKGROUND_EFFECT_STORAGE_KEY = 'archon.backgroundEffect';

/** @param {unknown} value */
export function isValidBackgroundEffect(value) {
  return (
    value === ARCHON_BACKGROUND_EFFECTS.SILK ||
    value === ARCHON_BACKGROUND_EFFECTS.LIQUID_ETHER
  );
}

/** @param {unknown} value @returns {ArchonBackgroundEffectId} */
export function normalizeBackgroundEffect(value) {
  return isValidBackgroundEffect(value) ? value : DEFAULT_BACKGROUND_EFFECT;
}

/** Metadata for Settings → Display picker. */
export const BACKGROUND_EFFECT_OPTIONS = Object.freeze([
  Object.freeze({
    id: ARCHON_BACKGROUND_EFFECTS.SILK,
    label: 'Waves',
    description: 'Flowing wave patterns behind the desktop logo. Classic Archon look.',
    previewClass: 'archon-bg-effect-preview--waves',
  }),
  Object.freeze({
    id: ARCHON_BACKGROUND_EFFECTS.LIQUID_ETHER,
    label: 'Fluid',
    description: 'Interactive fluid simulation that drifts and responds to the cursor.',
    previewClass: 'archon-bg-effect-preview--fluid',
  }),
]);
